const setItemInLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

const removeItemFromLocalStorage = (key: string) => {
  return localStorage.removeItem(key);
};

const getItemFromLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const localStorageHelpers = {
  setItemInLocalStorage,
  removeItemFromLocalStorage,
  getItemFromLocalStorage,
};
